<template>
  <footer class="section has-background-codeasy has-shadow" id="contact">
    <div class="column is-offset-1 is-10">
      <div class="columns is-mobile is-centered v-column-mobile">
        <div class="column v-column-mobile">
          <div class="columns v-m-b-0">
            <div class="column is-two-thirds">
              <figure class="image v-column-mobile">
                <picture>
                  <source :srcset="logo.newImageFormat" type="image/webp">
                  <img :src="logo.traditionalImageFormat" :alt="logo.alt">
                </picture>
              </figure>
            </div>
          </div>
          <div class="column is-paddingless">
            <h4
              class="has-text-white is-size-5"
              style="letter-spacing: 1px; padding-bottom: 0.75rem;"
            >
              <strong class="has-text-white">We speak your language.</strong>
            </h4>
            <p class="has-text-white v-is-hidden-mobile">
              Our product experts
              gain a deep understanding of your business
              before we write single line of code.
            </p>
          </div>
        </div>
        <hr class="v-is-hidden-tablet">
        <div class="column has-text-bottom v-column-mobile">
          <h4 class="has-text-white v-column-mobile">
            <strong class="has-text-codeasy-primary">Office:</strong>
          </h4>
          <h4 class="has-text-white v-column-mobile">Antuna Gustava Matoša 43</h4>
          <h4 class="has-text-white v-column-mobile">21210 - Solin</h4>
          <h4 class="has-text-white v-column-mobile">Croatia</h4>

          <div class="mail-container">
            <a
              :href="mailTo"
              target="_blank"
              class="has-text-white v-column-mobile"
              v-for="(char, index) in mail"
              :key="index"
            >
              <span>{{ char }}</span>
            </a>
          </div>
        </div>
        <div class="column v-column-mobile has-text-bottom">
          <h4 class="has-text-white has-text-right is-size-7-mobile">Copyright © Codeasy 2019</h4>
          <h4 class="has-text-white has-text-right is-size-7-mobile">All rights reserved</h4>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'Footer',
  data () {
    return {
      mailPrefix: '109|97|105|108|116|111|58',
      mailSuffix: '105|110|102|111|64|99|111|100|101|97|115|121|46|99|111|109',
      mailTo: '',
      mail: '',
      logo: {
        traditionalImageFormat: require('@/assets/logo-name.png'),
        newImageFormat: require('@/assets/logo-name.webp'),
        alt: 'Codeasy logo',
      },
    }
  },
  methods: {
    generateMailTo () {
      this.mailTo = `${String.fromCharCode(
        ...this.mailPrefix.split('|')
      )}${String.fromCharCode(...this.mailSuffix.split('|'))}`
    },
    generateMail () {
      this.mail = String.fromCharCode(...this.mailSuffix.split('|')).split('')
    },
  },
  mounted () {
    this.generateMailTo()
    this.generateMail()
  },
}
</script>

<style lang="scss" scoped>
@import "~bulma";

$sizes: (0, 10, 15, 20, 25, 30, 50);
$positions: ("t", "l", "b", "r", "a");
$positionsX: (
  "t": "-top",
  "b": "-bottom",
  "l": "-left",
  "r": "-right",
  "a": ""
);

@each $size in $sizes {
  @each $position, $key in $positionsX {
    .v-m-#{$position}-#{$size} {
      margin#{$key}: $size + px + !important;
    }
    .v-p-#{$position}-#{$size} {
      padding#{$key}: $size + px + !important;
    }
  }
}

.has-text-bottom {
  margin-top: auto;
}
.has-shadow {
  box-shadow: 0 -3px 5px -1px rgba(0, 0, 0, 0.2),
    0 -6px 10px 0 rgba(0, 0, 0, 0.14), 0 -1px 18px 0 rgba(0, 0, 0, 0.12);
}

hr {
  width: 96%;
  height: 1px;
  margin: 0 0 12px;
  background-color: #24a986;
}

@media screen and (max-width: 720px) {
  .v-column-mobile {
    display: flex;
    flex-direction: column !important;
    align-items: center;
  }
  .v-is-hidden-mobile {
    display: none;
  }
  .footer-logo-container {
    max-width: 60%;
  }
}

.mail-container {
  display: flex;
}

@media screen and (min-width: 720px) {
  .v-is-hidden-tablet {
    display: none;
  }
}
</style>
